export default __webpack_public_path__ + "static/SR China - Safety Data Sheet - Caramel Color (Liquid) - CN-dbcee9cac452e99a4bb904475969042f.pdf";